import { axios } from '@Root/API'

export const remove = (qualificationAwardId, qualificationAwardAccreditationId) => {
	return axios.delete(`qualification-awarded/${qualificationAwardId}/accreditation/${qualificationAwardAccreditationId}`)
}
